import React from 'react'
import Page from '../components/Page'
import { Button, Card, CardBody, CardHeader, Col, Label, Row, Table, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, TabContent, TabPane, Form, FormFeedback, FormGroup, FormText, Input } from 'reactstrap'
import axios from '../utils/posAxios'
import StorageService from '../services/StorageService'
import { MdCameraAlt, MdFace, MdDone, MdClear, MdCreate, MdAdd } from 'react-icons/md'
import { BsPlusSquareFill } from 'react-icons/bs'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Redirect } from 'react-router'
import classnames from 'classnames'
import PosShippingForm from '../components/PosShippingForm'
import { IconContext } from 'react-icons/lib'

class PosShippingTable extends React.Component {
  _isMounted = true
  constructor(props) {
    super(props)
    this.state = {
      shippingList: [],
      modal: false,
      confirmModal: false,
      id: '',
      name: '',
      shipping_code: '',
      location: '',
      shipping_type: '',
      country: '',
      ecart_country: [],
      fee: '',
      free_value: '',
      compare_value: '',
      selectedData: '',
      selectedCountry: '',
      selectedId: '',
      store_id: '',
    }
  }

  componentDidMount() {
    this.Shipping()
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  Shipping = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    }

    let fullUrl,
      store_id = ''
    if (!this.props.isGlobal) {
      store_id = this.props.data.store_id
      data.store_id = store_id
      fullUrl = url + ':3001/v2/store/shipping'
    } else {
      fullUrl = url + ':3001/v2/shipping'
    }

    axios
      .post(fullUrl, data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }

        if (this._isMounted) {
          this.setState({
            shippingList: this.props.isGlobal ? result.data : result.data.shipping,
            ecart_country: this.props.isGlobal ? [] : result.data.country,
            store_id: store_id,
            isGlobal: this.props.isGlobal,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  toggle = (action, id) => () => {
    return this.setState({
      modal: !this.state.modal,
      isEdit: id != undefined || (id != null && action == 'EDIT') ? true : false,
      selectedId: id != undefined || (id != null && action == 'EDIT') ? id : '',
    })
  }

  toggleConfirmModal =
    (name, id, country = null) =>
    () => {
      return this.setState({
        confirmModal: !this.state.confirmModal,
        selectedData: name,
        selectedId: id,
        selectedCountry: country,
      })
    }

  closeModal = (title, message, level, reload) => {
    this.notificationSystem.addNotification({
      title: title,
      message: message,
      level: level,
      position: 'br',
      autoDismiss: 2,
      dismissible: 'click',
    })

    this.setState({
      modal: false,
    })

    if (reload) {
      window.location.reload()
    } else {
      this.Shipping()
    }
  }

  delete = () => {
    const user = StorageService.getSession('user_info')
    const url = process.env.REACT_APP_UNITY_API2_URL

    let data, fullUrl
    if (this.state.isGlobal) {
      data = {
        session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
        shipping_id: this.state.selectedId,
        delete_by: user.email,
      }
      fullUrl = url + ':3001/v1/shipping/delete'
    } else {
      data = {
        session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
        shipping_id: this.state.selectedId,
        store_id: this.props.data.store_id,
        country: this.state.selectedCountry,
        remove_by: user.email,
      }
      fullUrl = url + ':3001/v2/store/shipping/remove'
    }

    axios
      .post(fullUrl, data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          })
          return
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: `Shipping ${this.state.isGlobal ? 'deleted' : 'removed'} successfully.`,
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.setState({ confirmModal: false })
        this.Shipping()
      })
      .catch(error => {
        alert(error)
      })
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/" />
    }
    return (
      <>
        <NotificationSystem dismissible={false} ref={notificationSystem => (this.notificationSystem = notificationSystem)} style={NOTIFICATION_SYSTEM_STYLE} />
        <div className="text-right mb-3">
          <div className="ps-btn-group">
            <Button color="link" onClick={this.toggle('ADD', null)}>
              <IconContext.Provider value={{ color: '#2a2c6b' }}>
                <BsPlusSquareFill size={25} />
              </IconContext.Provider>
            </Button>
          </div>
        </div>
        <Table responsive hover className={`ps-table ${this.state.isGlobal ? 'tb-col-9' : 'tb-col-10'}`}>
          <thead>
            <tr>
              <th>Name</th>
              <th>Code</th>
              <th>Location</th>
              <th>Type</th>
              {!this.state.isGlobal && <th>Country</th>}
              <th>Fee</th>
              <th>Free Value</th>
              <th>Auto Include</th>
              <th>Fee Type</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {this.state.shippingList.length < 1 && (
              <tr>
                <td colSpan={this.state.isGlobal ? '9' : '10'}>
                  <div className="ps-empty-data">
                    <div className="empty-content">
                      <MdCreate />
                      <h4>No data to show</h4>
                      <span>Click the 'Create' button to add new promo</span>
                    </div>
                  </div>
                </td>
              </tr>
            )}

            {this.state.shippingList.length > 0 &&
              this.state.shippingList.map((item, index) => {
                return (
                  <tr key={index}>
                    <td>{item.name}</td>
                    <td>{item.shipping_code}</td>
                    <td>{item.location}</td>
                    <td>{item.shipping_type}</td>
                    {!this.state.isGlobal && <td>{item.country}</td>}
                    <td>{item.fee}</td>
                    <td>{item.free_value}</td>
                    <td>
                      <span className={'ps-indicator ' + (item.required == '1' ? 'on' : 'off')}>{item.required == '1' ? 'Yes' : 'No'}</span>
                    </td>
                    <td>{item.fee_type}</td>
                    <td>
                      <div className="ps-action-button">
                        {this.state.isGlobal && (
                          <Button className="theme-button theme-button-secondary" onClick={this.toggle('EDIT', item.id)}>
                            Edit
                          </Button>
                        )}
                        <Button className="theme-button theme-button-primary-light" onClick={this.toggleConfirmModal(item.name, item.id, item.country)}>
                          {this.state.isGlobal ? 'Delete' : 'Remove'}
                        </Button>
                      </div>
                    </td>
                  </tr>
                )
              })}
          </tbody>
        </Table>
        <Modal isOpen={this.state.modal} toggle={this.toggle()} className={this.props.className} centered>
          <PosShippingForm history={this.props.history} onToggleModal={this.toggle} closeModal={this.closeModal} match={this.props.match} data={this.state} />
        </Modal>
        <Modal isOpen={this.state.confirmModal} toggle={this.toggleConfirmModal()} className={this.props.className} centered style={{ fontSize: '0.85rem' }}>
          <ModalHeader toggle={this.toggleConfirmModal()}>{this.state.isGlobal ? 'Delete' : 'Remove'} Shipping</ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12}>
                <p>
                  Are you sure you want to {this.state.isGlobal ? 'delete' : 'remove'} {this.state.selectedData} {this.state.selectedCountry && '(' + this.state.selectedCountry + ')'}?
                </p>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button className="theme-button theme-button-secondary" onClick={this.toggleConfirmModal()}>
              No
            </Button>
            <Button className="theme-button theme-button-primary" onClick={() => this.delete()}>
              Yes
            </Button>
          </ModalFooter>
        </Modal>
      </>
    )
  }
}

export default PosShippingTable
